<template>
  <div>
    <v-card>
      <v-toolbar flat dark color="secondary">
        <v-toolbar-title :style="$store.state.textFormatting.headers">
          Platform Status: {{ motdStr }} 
        </v-toolbar-title>
        <v-spacer />
        <v-flex shrink>
          <v-btn
            @click="showCard = !showCard"
            v-if="showCard"
            dark
            fab
            small
            color="blue"
            ><h2>-</h2></v-btn
          >
          <v-btn
            @click="showCard = !showCard"
            v-if="!showCard"
            dark
            fab
            small
            color="blue"
            ><h2>+</h2></v-btn
          >
        </v-flex>
      </v-toolbar>
      <v-card-text class="body-2" v-if="showCard">
        <div class="body-2">
          <h3
            display-1
            :style="$store.state.textFormatting.main"
            class="text-xs-center"
          >
          More Information
          </h3>
          <br />
          <hr />
          <br />
          <p>{{ mainmessage }}</p>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { API, graphqlOperation } from "aws-amplify";

export default {
  name: "motdbanner",
  data() {
    return { 
      showCard: false,
      motdStr: "Waiting..." 
      };
  },
  beforeMount() {
    this.getMOTD();
  },
  mounted() {
    this.getMOTD();
  },
  methods: {
    getMOTD: async function () {
      try {
        var query = `query getMOTD { getMOTD { message, msgtext } }`;
        const motd = await API.graphql(graphqlOperation(query));
        this.motdStr = motd.data.getMOTD.message;
        this.mainmessage = motd.data.getMOTD.msgtext;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
